import { httpApi } from '@api/http.api.ts';

export interface EmbeddedContentApiResponse {
    isContentReady: boolean;
    url: string;
    contentMinutesDuration: number;
}
// here we put direct embededURL: "//learning/embedded/some-id", so the both endpoints similar
export const getApiEmbeddedContentUri = (embeddedUrl: string): Promise<EmbeddedContentApiResponse> =>
    httpApi.get<EmbeddedContentApiResponse>(embeddedUrl).then(({ data }) => data);

export const getApiContentUri = (contentId: string): Promise<EmbeddedContentApiResponse> =>
    httpApi.get<EmbeddedContentApiResponse>(`learning/embedded/${contentId}`).then(({ data }) => data);
